export * from './lib/hosted-auth';

export { default as WhatsappIcon } from './lib/icon.svg';
export const whatsappName = 'WhatsApp';
